module.exports = "<h1 style=\"color:blue\">\n  about works!\n</h1>\n"